import { Link } from 'shared/lib/i18n';
import type { Project } from '@/enteties/project/modal';
import { StatusChip } from '@/enteties/project/ui';
import type { ReactNode } from 'react';
import { ProjectCardInstances, ProjectCardResourceStatus, ProjectCardTokens } from './project-card-children';
import { ProjectCardContext } from './project-card-context';
interface ProjectCardProps {
  project: Project;
  projectType: 'db' | 'applications' | 'pre-configured';
  children: ReactNode;
}
export function ProjectCard({
  project,
  projectType,
  children
}: ProjectCardProps) {
  return <Link scroll href={`/projects/${projectType}/${project.slug}`} data-sentry-element="Link" data-sentry-component="ProjectCard" data-sentry-source-file="project-card.tsx">
      <div className="flex h-[68px] w-full items-center justify-between rounded-lg bg-accent px-6">
        <div className="flex items-center gap-6 pr-3  lg:flex-1">
          <p className="mb-0.5 align-middle text-title3">{project.name}</p>
          <StatusChip status={project.status} data-sentry-element="StatusChip" data-sentry-source-file="project-card.tsx" />
        </div>
        <div className="flex gap-4 items-center justify-end lg:justify-between lg:flex-1">
          <ProjectCardContext.Provider value={{
          slug: project.slug
        }} data-sentry-element="unknown" data-sentry-source-file="project-card.tsx">
            {children}
          </ProjectCardContext.Provider>
        </div>
      </div>
    </Link>;
}
ProjectCard.Instances = ProjectCardInstances;
ProjectCard.ResourceStatus = ProjectCardResourceStatus;
ProjectCard.Tokens = ProjectCardTokens;